import DataPenunjang from "@/services/DataPenunjang";
import {
  OrderPenunjang,
  PenunjangGroup,
  OrderLab,
  OrderRadiologi
} from "@/types";

import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import _ from "lodash";
import { appModule } from "./app";
import PaketOrder from "@/services/PaketOrder";
import { userModule } from "./user";

export interface PenunjangState {
  penunjangGroupLab: PenunjangGroup[];
  penunjangGroupRadiologi: PenunjangGroup[];
  orderLab: OrderPenunjang;
  orderRadiologi: OrderPenunjang;
  listorderLab: OrderLab[];
  listorderRadiologi: OrderRadiologi[];
  template: Template;
}
interface TemplateItems {
  id: number;
  nama: string;
  items: Array<object>;
  type?: string;
}
interface Template {
  paket: TemplateItems[];
  user: TemplateItems[];
}
interface ListHasilRo {
  no_trans: string;
  tgl: string;
  dr_pengirim: string;
  dr_radiologi: string;
  unit: object;
  item: Array<object>;
}
interface HasilRo {
  tgl_trans: string;
  no_trans: string;
  cm: string;
  acc_number: string;
  serviceCode: string;
  description: string;
  reportDate: string;
  dokter: string;
  link: string;
}
interface ListHasilLab {
  no_order: string;
  tgl_order: string;
  rm: string;
  nama: string;
  lis_sampel: string;
  acc_by: string;
  acc_date: string;
  result_test: Array<object>;
}
interface HasilLab {
  test_id: string;
  nama_test: string;
  jenis_hasil: string;
  hasil: string;
  satuan: string;
  nilai_normal: string;
  flag: string;
  kode_paket: string;
}
interface KategoriPenunjangLain {
  id: string;
  nama: string;
}
interface KbMetode {
  kode: number;
  nama: string;
  kelompok: string;
  kontap: boolean;
  label: string;
}
interface PenunjangLain {
  id: number;
  tanggal: string;
  pasien: {
    rm: string;
    nama: string;
  };
  register_id: number;
  waktu_periksa: string;
  penunjang_lain_kategori: {
    id: string;
    nama: string;
  };
  kb_metode_kode: number;
  kb_metode_nama: string;
  unit: {
    id: string;
    nama: string;
  };
  catatan: string;
  user: {
    id: string;
    nama: string;
  };
  dokter: {
    id: string;
    nama: string;
  };
  file: Array<object>;
}

@Module({ store, dynamic: true, name: "storePenunjang" })
class PenunjangStore extends VuexModule implements PenunjangState {
  penunjangGroupLab: PenunjangGroup[] = [];
  penunjangGroupRadiologi: PenunjangGroup[] = [];
  orderLab = {} as OrderPenunjang;
  orderRadiologi = {} as OrderPenunjang;
  listorderLab: OrderLab[] = [];
  listorderRadiologi: OrderRadiologi[] = [];
  template: Template = null;
  listhasilRadiologi: ListHasilRo[] = [];
  listhasilLab: ListHasilLab[] = [];

  listRadiologi: ListHasilRo[] = [];
  listLab: ListHasilLab[] = [];

  hasilRadiologi = {} as HasilRo;
  msgHasilRadiologi = "";

  hasilLaboratorium = {} as HasilLab;
  hasilLabTrn: HasilLab[] = [];
  kategoriPenunjangLain: KategoriPenunjangLain[] = [];
  kbMetode: KbMetode[] = [];
  penunjanglain: PenunjangLain[] = [];
  riwayatpenunjanglain = [];
  loadingOrderLab = false;
  loadingOrderRadiologi = false;
  loadingHasilLab = false;
  loadingHasilRadiologi = false;
  loadingTemplate = false;

  get stateUser() {
    return userModule;
  }

  @Mutation SET_GROUP_ITEM_LAB(penunjangGroupLab: PenunjangGroup[]) {
    this.penunjangGroupLab = penunjangGroupLab;
  }
  @Mutation SET_GROUP_ITEM_RO(penunjangGroupRadiologi: PenunjangGroup[]) {
    this.penunjangGroupRadiologi = penunjangGroupRadiologi;
  }
  @Mutation SET_ORDER_LAB(orderLab: OrderPenunjang) {
    this.orderLab = orderLab;
  }
  @Mutation SET_ORDER_RADIOLOGI(orderRadiologi: OrderPenunjang) {
    this.orderRadiologi = orderRadiologi;
  }
  @Mutation SET_LIST_ORDER_LAB(listorderLab: OrderLab[]) {
    this.listorderLab = listorderLab;
  }
  @Mutation SET_LIST_ORDER_RADIOLOGI(listorderRadiologi: OrderRadiologi[]) {
    this.listorderRadiologi = listorderRadiologi;
  }
  @Mutation SET_LIST_TEMPLATE_PENUNJANG(template: Template) {
    this.template = template;
  }
  @Mutation SET_LIST_HASIL_RO(listhasilRadiologi: ListHasilRo[]) {
    this.listhasilRadiologi = listhasilRadiologi;
  }
  @Mutation SET_LIST_RO(listRadiologi: ListHasilRo[]) {
    this.listRadiologi = listRadiologi;
  }
  @Mutation SET_HASIL_RO(hasilRadiologi: HasilRo, msg) {
    console.log("set hasil ro", hasilRadiologi, msg);
    this.hasilRadiologi = hasilRadiologi;
    this.msgHasilRadiologi = msg;
  }
  @Mutation SET_LIST_HASIL_LAB(listhasilLab: ListHasilLab[]) {
    this.listhasilLab = listhasilLab;
  }
  @Mutation SET_LIST_LAB(listLab: ListHasilLab[]) {
    this.listLab = listLab;
  }
  @Mutation SET_HASIL_LAB(hasilLaboratorium: HasilLab) {
    this.hasilLaboratorium = hasilLaboratorium;
  }
  @Mutation SET_HASIL_TRN_LAB(hasilLabTrn: HasilLab[]) {
    this.hasilLabTrn = hasilLabTrn;
  }
  @Mutation SET_KATEGORI_PENUNJANG_LAIN(
    kategoriPenunjangLain: KategoriPenunjangLain[]
  ) {
    this.kategoriPenunjangLain = kategoriPenunjangLain;
  }
  @Mutation SET_KB_METODE(kbMetode: KbMetode[]) {
    this.kbMetode = kbMetode;
  }
  @Mutation SET_PENUNJANG_LAIN(penunjanglain = []) {
    this.penunjanglain = penunjanglain;
  }
  @Mutation SET_RIWAYAT_PENUNJANG_LAIN(riwayatpenunjanglain = []) {
    this.riwayatpenunjanglain = riwayatpenunjanglain;
  }
  @Mutation SET_LOADING_ORDER_LAB(val: boolean) {
    this.loadingOrderLab = val;
  }
  @Mutation SET_LOADING_ORDER_RO(val: boolean) {
    this.loadingOrderRadiologi = val;
  }
  @Mutation SET_LOADING_HASIL_LAB(val: boolean) {
    this.loadingHasilLab = val;
  }
  @Mutation SET_LOADING_HASIL_RO(val: boolean) {
    this.loadingHasilRadiologi = val;
  }
  @Mutation SET_LOADING_TEMPLATE(val: boolean) {
    this.loadingTemplate = val;
  }

  @Action act_item_group_lab() {
    // appModule.setLoading(true);
    const dt = DataPenunjang.getListLab();
    dt.then(dt => {
      // appModule.setLoading(false);
      const penunjangGroupLab = _.orderBy(
        dt,
        group => {
          return group.items.length;
        },
        ["asc"]
      );

      this.SET_GROUP_ITEM_LAB(penunjangGroupLab);
    });
  }

  @Action act_item_group_radiologi() {
    // appModule.setLoading(true);
    const dt = DataPenunjang.getListRadiologi();
    dt.then(dt => {
      // appModule.setLoading(false);
      const penunjangGroupRadiologi = _.orderBy(
        dt,
        group => {
          return group.items.length;
        },
        ["asc"]
      );

      this.SET_GROUP_ITEM_RO(penunjangGroupRadiologi);
    });
  }
  @Action act_all_order_lab_by_reg(reg) {
    // appModule.setLoading(true);
    this.SET_LOADING_ORDER_LAB(true);

    const dt = DataPenunjang.getDataOrderLabByReg(reg);
    dt.then(dt => {
      this.SET_LOADING_ORDER_LAB(false);

      const orderlab = dt.data;
      // console.log('ccc', orderlab)
      this.SET_LIST_ORDER_LAB(orderlab);
    });
  }

  @Action act_all_order_radiologi_by_reg(reg) {
    this.SET_LOADING_ORDER_RO(true);

    const dt = DataPenunjang.getDataOrderRadiologiByReg(reg);
    dt.then(dt => {
      this.SET_LOADING_ORDER_RO(false);

      const orderradiologi = dt.data;
      this.SET_LIST_ORDER_RADIOLOGI(orderradiologi);
    });
  }

  @Action act_order_lab_byId(id) {
    appModule.setLoading(true);
    const dt = DataPenunjang.getDataOrderLabById(id);
    dt.then(dt => {
      appModule.setLoading(false);
      const orderLab = dt.data;
      this.SET_ORDER_LAB(orderLab);
    });
  }
  @Action act_order_radiologi_byId(id) {
    appModule.setLoading(true);
    const dt = DataPenunjang.getDataOrderRadiologiById(id);
    dt.then(dt => {
      appModule.setLoading(false);
      const orderRadiologi = dt.data;

      this.SET_ORDER_RADIOLOGI(orderRadiologi);
    });
  }
  @Action({ rawError: true }) async act_template_penunjang(type) {
    this.SET_LOADING_TEMPLATE(true);

    const template = {
      paket: [],
      user: []
    };

    const dt = await DataPenunjang.getDataTemplate(type);

    template.user = dt.data;

    if (type == "lab" && this.stateUser.user.unit_id == "01") {
      const paket = await PaketOrder.getPaketLabByUnit(
        this.stateUser.user.unit_id
      );

      template.paket = paket.data;
    }

    this.SET_LIST_TEMPLATE_PENUNJANG(template);

    this.SET_LOADING_TEMPLATE(false);
  }
  @Action act_list_ro_byReg(reg) {
    this.SET_LOADING_HASIL_RO(true);

    const dt = DataPenunjang.getDataListHasilRo(reg);
    dt.then(dt => {
      this.SET_LOADING_HASIL_RO(false);

      const listRo = dt.data;
      this.SET_LIST_HASIL_RO(listRo);
    });
  }
  @Action act_list_ro_byRm(rm) {
    this.SET_LOADING_HASIL_RO(true);

    const dt = DataPenunjang.getDataListHasilRoByRm(rm);
    dt.then(dt => {
      this.SET_LOADING_HASIL_RO(false);

      const listRo = dt.data;
      this.SET_LIST_HASIL_RO(listRo);
    });
  }
  @Action act_hasil_ro_byReg(param: any) {
    const no_trans = param["no_transaksi"];
    const tgl = param["tgl"];
    const kode = param["kode"];
    appModule.setLoading(true);
    const dt = DataPenunjang.getDataDetailHasilRo(no_trans, tgl, kode);
    dt.then(dt => {
      appModule.setLoading(false);
      console.log("hasilRo", dt);
      console.log("msgHasilRo", dt.message);

      this.SET_HASIL_RO(dt.data, "asdf");
    });
  }
  @Action act_list_lab_byReg(reg) {
    this.SET_LOADING_HASIL_LAB(true);

    const dt = DataPenunjang.getDataListHasilLab(reg);
    dt.then(dt => {
      this.SET_LOADING_HASIL_LAB(false);

      const listLab = dt.data;
      this.SET_LIST_HASIL_LAB(listLab);
    });
  }

  @Action clear_list_ro() {
    const listRo = [];
    this.SET_LIST_HASIL_RO(listRo);
  }
  @Action clear_list_lab() {
    const listLab = [];
    this.SET_LIST_HASIL_LAB(listLab);
  }
  @Action clear_hasil_lab() {
    // alert("aa")
    const hasilLab = {
      test_id: "",
      nama_test: "",
      jenis_hasil: "",
      hasil: "",
      satuan: "",
      nilai_normal: "",
      flag: "",
      kode_paket: ""
    };
    this.SET_HASIL_LAB(hasilLab);
  }
  @Action clear_hasil_ro() {
    // alert("aa")
    const hasilRo = {
      tgl_trans: "",
      no_trans: "",
      cm: "",
      acc_number: "",
      serviceCode: "",
      description: "",
      reportDate: "",
      dokter: "",
      link: ""
    };
    this.SET_HASIL_RO(hasilRo, "");
  }

  @Action({ rawError: true })
  async act_list_lab_byRm(param: any) {
    this.SET_LOADING_HASIL_LAB(true);

    const rm = param["rm"];
    const tgl_masuk = param["masuk"];
    const tgl_keluar = param["keluar"];

    const dt = DataPenunjang.getDataListHasilLabByRm(rm, tgl_masuk, tgl_keluar);

    dt.then(dt => {
      this.SET_LOADING_HASIL_LAB(false);

      const listLab = dt.data;
      this.SET_LIST_HASIL_LAB(listLab);
    });
  }

  @Action({ rawError: true })
  async act_kategori_penunjang_lain() {
    const dt = DataPenunjang.getDataKategoriPenunjangLain();
    dt.then(dt => {
      appModule.setLoading(false);
      const data = dt;
      this.SET_KATEGORI_PENUNJANG_LAIN(data);
    });
  }

  @Action({ rawError: true })
  async act_kb_metode() {
    const dt = DataPenunjang.getDataKbMetode();
    dt.then(dt => {
      appModule.setLoading(false);
      if (Array.isArray(dt)) {
        this.SET_KB_METODE(dt);
      }
    });
  }

  @Action act_penunjang_lain_byReg(reg) {
    appModule.setLoading(true);
    const dt = DataPenunjang.getDataPenunjangLainByReg(reg);
    dt.then(dt => {
      appModule.setLoading(false);
      const data = dt.data;
      // this.SET_LIST_HASIL_LAB(data);
      this.SET_PENUNJANG_LAIN(data);
    });
    // const data = [
    //   {
    //     kategori: "ECG",
    //     waktu_periksa: "16-06-2021 10:12",
    //     link: "https://picsum.photos/350/165?random",
    //     type: "PNG",
    //     catatan: "aaaaaa",
    //     unit: "Klinik Jantung",
    //   },
    //   {
    //     kategori: "USG",
    //     waktu_periksa: "16-06-2021 11:20",
    //     link: "https://cdn.rawgit.com/mozilla/pdf.js/c6e8ca86/test/pdfs/freeculture.pdf",
    //     type: "PDF",
    //     catatan: "bbbbbb",
    //     unit: "Klinik Kebidanan",
    //   },
    //   {
    //     kategori: "ECG",
    //     waktu_periksa: "16-06-2021 12:12",
    //     link: "https://picsum.photos/510/300?random",
    //     type: "PNG",
    //     catatan: "cccccc",
    //     unit: "Klinik Jantung",
    //   },
    // ];
  }

  @Action clear_penunjang_lain() {
    const listPenunjangLain = [];
    this.SET_PENUNJANG_LAIN(listPenunjangLain);
  }
  @Action act_penunjang_lain_byRm(rm) {
    appModule.setLoading(true);
    const dt = DataPenunjang.getDataPenunjangLainByRm(rm);
    dt.then(dt => {
      appModule.setLoading(false);
      const data = dt.data;
      // console.log('data', data)
      this.SET_RIWAYAT_PENUNJANG_LAIN(data);
      // this.SET_PENUNJANG_LAIN(data);
    });
  }

  @Action
  delete_penunjang_lain_item(param) {
    appModule.setLoading(true);

    DataPenunjang.deletePenunjangLainItem(param.id).then(() => {
      appModule.setLoading(false);

      this.act_penunjang_lain_byReg(param.register_id);
    });
  }
  
  @Action get_list_ro_byRm(rm) {
    this.SET_LOADING_HASIL_RO(true);

    const dt = DataPenunjang.getDataListHasilRoByRm(rm);
    dt.then(dt => {
      this.SET_LOADING_HASIL_RO(false);

      const listRo = dt.data;
      this.SET_LIST_RO(listRo);
    });
  }

  @Action({ rawError: true })
  async get_list_lab_byRm(param: any) {
    this.SET_LOADING_HASIL_LAB(true);

    const rm = param["rm"];
    const tgl_masuk = param["masuk"];
    const tgl_keluar = param["keluar"];

    const dt = DataPenunjang.getDataListHasilLabByRm(rm, tgl_masuk, tgl_keluar);

    dt.then(dt => {
      this.SET_LOADING_HASIL_LAB(false);

      const listLab = dt.data;
      this.SET_LIST_LAB(listLab);
    });
  }
  @Action clear_list_lab_ro() {
    this.SET_LIST_LAB([]);
    this.SET_LIST_RO([]);
  }

  @Action reset() {
    this.SET_LIST_ORDER_LAB([]);
    this.SET_LIST_ORDER_RADIOLOGI([]);
    this.SET_LIST_HASIL_LAB([]);
    this.SET_LIST_HASIL_RO([]);
  }

    
}

export const storePenunjang = getModule(PenunjangStore);
